import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=ba6c4b10&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=ba6c4b10&scoped=true&lang=css"
import style1 from "./CommentItem.vue?vue&type=style&index=1&id=ba6c4b10&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6c4b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba6c4b10')) {
      api.createRecord('ba6c4b10', component.options)
    } else {
      api.reload('ba6c4b10', component.options)
    }
    module.hot.accept("./CommentItem.vue?vue&type=template&id=ba6c4b10&scoped=true", function () {
      api.rerender('ba6c4b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/share/CommentItem.vue"
export default component.exports